import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Input,
  notification,
  Modal,
  Checkbox,
} from "antd";
import { Link, useLocation } from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import LoginPic from "../assets/images/tahsilat-glass-logo-png.png";
import LoginPicImza from "../assets/images/imzaPosLogo.png";
import LoginPicBakiyem from "../assets/images/logoBakiyem.png";
import Screen from "../util/Extensions/Screens";
import { useSelector } from "react-redux";
import RequestHandler from "../util/RequestHandler";
import { markOpenBannerPromoOnNextLoad } from "../util/BannerPromoSession";
import BannerSlider from "../components/Banner/BannerSlider";
import RegisterPic from "../assets/images/tahsilat_screen3.png";
import ParaticPhoneInput from "../routes/Forms/Helper/ParaticPhoneInput";

const SignIn = (props) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [visible, setVisible] = useState(false);
  const [otpType, setOtpType] = useState("");
  const [mailLogin, setMailLogin] = useState("");
  const [psr, setPsr] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const { initialMinute = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(180);
  const [errorText, setErrorText] = useState("");
  const [confidentialAgreement, setconfidentialAgreement] = useState(
    "/gizlilik-ve-guvenlik-politikasi.pdf"
  );
  const [salesAgreement, setSalesAgreement] = useState("/tuketici-haklari.pdf");
  const [registerLoading, setRegisterLoading] = useState(false);
  const params = new URLSearchParams(location.search);
  const utmSource = params.get("utm_source");
  const utmMedium = params.get("utm_medium");
  const utmCampaign = params.get("utm_campaign");
  const [businessPartnerId, setBusinessPartnerId] = useState(null);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          handleCancel();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const [form] = Form.useForm();

  const showModal = (otpType) => {
    setOtpType(otpType);
    setSeconds(180);
    setOtpInput("");
    setErrorText("");
    setVisible(true);
  };

  const handleSubmit = (values) => {
    RequestHandler.post(
      `/Auth/Login`,
      {
        email: mailLogin,
        password: psr,
        screenOption: Screen.screen,
        securityKey: values.otp,
      },
      false
    ).then((response) => {
      if (response.success) {
        setLoading(false);
        RequestHandler.setUserInfo(response);
        markOpenBannerPromoOnNextLoad();
        window.location.reload();
      } else {
        setLoading(false);
        setLoadingBtn(false);
      }
    });
  };

  const handleCancel = () => {
    if (handleCancel) {
      setLoading(false);
    }
    setVisible(false);
    setLoadingBtn(false);
  };

  const token = useSelector(({ auth }) => auth.token);
  const onFinishFailed = () => setLoading(false);

  const onFinish = (values) => {
    // axios.get(`${config.apiUrl}/Auth/PsrControl?email=${values.email}`).then(({data}) => {
    //     if(data === null || data === ""){
    RequestHandler.post(
      `/Auth/Login`,
      {
        email: values.email,
        password: values.password,
        screenOption: Screen.screen,
      },
      false
    ).then((response) => {
      if (response.success) {
        if (response.message === "smsOtp" || response.message === "mailOtp") {
          showModal(response.message);
          setMailLogin(values.email);
          setPsr(values.password);
        } else {
          RequestHandler.setUserInfo(response);
          openNotificationWithIcon("success");
          markOpenBannerPromoOnNextLoad();
          window.location.reload();
        }
      } else {
        setLoading(false);
      }
    });
    // }else{
    //   props.history.push(`/reset-password/${data}/true`);
    // }
    // }).catch(function (error) {
    //   if(error.response.status === 406){
    //     error.response.data.data.map((item)=>{
    //       errorList.push(item);
    //     })
    //     errorListNotification('error')
    //     setLoadingBtn(false)
    //     setLoading(false)
    //     }else{
    //         sameError('error')
    //         setLoading(false)
    //         setLoadingBtn(false)
    //     }
    //   });
  };

  const onChangePsrLoginValue = (e) => {
    setErrorText("");
    setOtpInput(e.target.value);
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Giriş işlemi başarılı.",
      duration: 2,
    });
  };

  const openNotificationRegister = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Kayıt işlemi başarılı.",
      duration: 2,
    });
  };

  const ref = useRef();

  useEffect(() => {
    if (token !== null) {
      if (location.state && location.state.from) {
        props.history.push(location.state.from.pathname);
      } else {
        props.history.push("/home");
      }
    }
  }, [token, props.history]);


  useEffect(() => {
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");
    const utmCampaign = params.get("utm_campaign");

    if (utmSource) {
      setBusinessPartnerId(utmSource);
    }
    // Google Analytics'e UTM parametrelerini gönder
    if (
      utmSource &&
      utmMedium &&
      utmCampaign &&
      typeof window.gtag === "function"
    ) {
      window.gtag("event", "sign_in", {
        event_category: "utm_campaign",
        event_label: `${utmSource} - ${utmMedium} - ${utmCampaign}`,
      });
    }
  }, [location.search]);

  return (
    <div className="flex h-screen">
      <Col xs={24} md={24} lg={24}>
        <Row>
          {/* Resim - Orijinal halinde kalıyor */}
          <Col
            xs={0}
            md={12}
            lg={12}
            style={{ height: "100vh", padding: 0, margin: 0 }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={RegisterPic}
                alt="Tahsilite"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "inherit",
                }}
              />
            </div>
          </Col>

          {/* Giriş Formu */}
          <Col
            xs={24}
            md={12}
            lg={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              minHeight: "100vh",
            }}
          >
            <div className="gx-login-content">
              <div className="gx-login-header gx-text-center">
                <h1 className="gx-login-title">
                  <img
                    src={LoginPic} // Burada istediğiniz resmi kullanın
                    alt="Tahsilite"
                    style={{
                      width: "60%",
                      marginBottom: "inherit",
                    }}
                  />
                </h1>
              </div>
              <Form
                initialValues={{ remember: true }}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="gx-signin-form gx-form-row0"
              >
                <Form.Item
                  rules={[
                    { required: true, message: "Email alanı zorunludur!" },
                  ]}
                  name="email"
                >
                  <Input
                    prefix={
                      <UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    placeholder="Email"
                    autoComplete={false}
                  />
                </Form.Item>
                <Form.Item
                  rules={[
                    { required: true, message: "Şifre alanı zorunludur!" },
                  ]}
                  name="password"
                >
                  <Input
                    prefix={
                      <LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    type="password"
                    placeholder="Şifre"
                    autoComplete={false}
                  />
                </Form.Item>
                <Link className="gx-login-form-forgot" to="/forget-password">
                  Şifremi Unuttum
                </Link>
                <Form.Item
                  className="gx-text-center"
                  style={{ marginTop: "5%" }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Giriş Yap
                  </Button>
                </Form.Item>
                <p
                  style={{
                    textAlign: "center",
                    marginBottom: "10%",
                    marginTop: "revert",
                  }}
                >
                  Hesabın yok mu?{" "}
                  <Link
                    to="/signup"
                    style={{
                      color: "#0253f4",
                      fontWeight: "bold",
                      marginBottom: "10%",
                    }}
                  >
                    Kayıt Ol
                  </Link>
                </p>
              </Form>
            </div>

            <div
              style={{
                position: "absolute",
                bottom: 20,
                left: "50%",
                transform: "translateX(-50%)",
                width: "100%",
                maxWidth: 900,
                zIndex: 10,
              }}
            >
              <BannerSlider
                screenName="SignInPage"
                isLogin={true}
                hideOnScroll={false}
                controlParameter={false}
                showBanner={true}
                closable
                isLoginPage
              />
            </div>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default SignIn;
